import { styled } from '@mui/material';
import classNames from 'classnames';
import { useCallback } from 'react';

export const Selection = ({
  rect,
  className,
  children,
  placement = 'top',
  ...rest
}: {
  rect: DOMRect | null;
  className?: string;
  placement?: 'top' | 'left';
  children?: React.ReactNode;
}) => {
  const ref = useCallback(
    (element: HTMLDivElement) => {
      if (!element || !rect) return;

      const centerY = rect.top + rect.height / 2;
      const centerX = rect.left + rect.width / 2;

      switch (placement) {
        case 'top':
          element.style.transform = 'translate(-50%, calc(-50% - 4px))';
          element.style.left = `${centerX}px`;
          element.style.top = `${rect.top}px`;
          break;
        case 'left':
          element.style.left = `${rect.left}px`;
          element.style.transform = 'translate(calc(-50% - 4px), -50%)';
          element.style.top = `${centerY}px`;
          break;
      }
    },
    [rect, placement],
  );

  return (
    <StyledDiv
      className={classNames(placement, className)}
      ref={ref}
      {...rest}
      data-table-drag-handle
    >
      {children}
    </StyledDiv>
  );
};

const StyledDiv = styled('div')(({ theme }) => ({
  position: 'fixed',
  zIndex: 999,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.action.active}`,
  cursor: 'grab',
  '&:hover': {
    backgroundColor: theme.palette.action.hoverSolid,
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.top, &.bottom': {
    padding: theme.spacing(0, 0.5),
  },
  '&.left, &.right': {
    padding: theme.spacing(0.5, 0),
  },
}));
